<template>
  <v-app-bar :color="isDark ? 'gray50' : '#f5f5f5'" :clipped-left="$vuetify.breakpoint.lgAndUp" elevation="0" class="gray600--text">
    <v-btn icon color="gray950" @click.stop="$emit('toggle-drawer')">
      <v-icon>$layout</v-icon>
    </v-btn>

    <div style="width:1px;height:16px" class="gray200 mr-4 ml-1" />

    <div class="text-sm font-weight-semibold">
      {{ pageTitle }}
    </div>

    <v-spacer />

    <v-tooltip bottom>
      <template #activator="{ on, attrs }">
        <div v-bind="attrs" v-on="on" class="px-3 cursor-pointer" @click="$router.push('/chips')">
          <span v-for="(chip, index) in visible_chips.filter(c => !c.official)" :key="`chip_a_${index}`">
            <v-icon size="18" :color="chip.status == 'open' ? 'primary' : 'red'">{{ chip.status == 'open' ? 'mdi-cellphone-check' : 'mdi-cellphone-remove' }}</v-icon>
          </span>

          <span v-for="(chip, index) in visible_chips.filter(c => c.official)" :key="`chip_b_${index}`">
            <v-icon size="18" class="ml-1" :color="chip.status == 'open' ? 'primary' : 'red'">mdi-whatsapp</v-icon>
          </span>

          <span v-if="more_chips">
            <v-icon size="18" class="ml-1" color="gray600">mdi-plus-circle-outline</v-icon>
          </span>
        </div>
      </template>
      <span>Estado dos chips</span>
    </v-tooltip>

    <v-btn icon small class="mr-2" @click="toggleTheme" :title="isDark ? 'Tema claro' : 'Tema escuro'">
      <v-icon :color="isDark ? 'amber lighten-1' : 'gray700'">
        {{ isDark ? 'mdi-white-balance-sunny' : 'mdi-weather-night' }}
      </v-icon>
    </v-btn>

    <v-menu offset-y>
      <template #activator="{ on }">
        <ib-btn color="gray500" text small v-on="on">
          <v-icon class="gray950--text" left>
            mdi-bell
          </v-icon>
          <v-badge inline :color="isDark ? 'red' : 'red400'" :value="notificationLengthText" :content="notificationLengthText" offset-y="22" class="cursor-pointer mr-2" style="pointer-events: inherit;" />
        </ib-btn>
      </template>

      <v-list dense>
        <v-list-item @click="$router.push({ name: 'Atendimento' }).catch(() => { })">
          <v-list-item-title>
            {{ openConversations === 0 ? 'Sem atendimento humano aberto' : openConversations > 1 ? `${openConversations} atendimentos humanos em andamento` : `${openConversations} atendimento humano aberto` }}
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-app-bar>
</template>

<script>
import Api from "@/lib/Api";

export default {
  data() {
    return {
      chips: [],
      visible_chips: [],
      more_chips: false,
      isDark: false
    }
  },

  computed: {
    currentUser() {
      return this.$store.state.currentUser
    },
    pageTitle() {
      return this.$route.meta.title || this.$route.name
    },
    openConversations() {
      return this.$store.state.conversations.open_manual_count;
    },
    notificationLengthText() {
      const conversations = this.$store.state.conversations.open_manual_count;

      if (conversations <= 9) {
        return conversations;
      }

      return '9+';
    }

  },

  mounted() {
    this.getChips();
    this.loadTheme();

    //CHECAGEM BÁSICA DE CANAIS A CADA 120 SEGUNDOS
    setInterval(() => {
      this.getChips();
    }, 120 * 1000);
  },

  created() {
    this.$root.$refs.global = this;
  },

  methods: {
    loadTheme() {
      const stored = localStorage.getItem('theme_dark');
      this.isDark = stored === null ? this.$vuetify.theme.dark : stored === 'true';
      this.$vuetify.theme.dark = this.isDark;
    },

    toggleTheme() {
      this.isDark = !this.isDark;
      this.$vuetify.theme.dark = this.isDark;
      localStorage.setItem('theme_dark', this.isDark ? 'true' : 'false');
    },

    async getChips() {
      const resp = await Api.getChipNumbersByUser();
      this.more_chips = false;

      if (!resp?.error && resp?.message) {
        const chips = resp.message;
        this.chips = chips;

        if (chips.length <= 5) {
          this.visible_chips = chips.slice();
        } else {
          const prioritized = chips.filter(c => c?.status !== 'open');
          const rest = chips.filter(c => c?.status === 'open');

          const ordered = [...prioritized, ...rest];
          this.visible_chips = ordered.slice(0, 4);
          this.more_chips = true;
        }
      } else {
        this.chips = [];
        this.visible_chips = [];
      }
    }
  }
};
</script>
